export default "__VITE_ASSET__CBTTByX5__"